import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import * as Styled from './styled';

const ArticlePreview = ({
  first,
  title,
  description,
  img,
  url,
  date,
  blogDate,
  // category,
  author = {},
  imgStyle,
  group,
  isList,
  list,
  timeToRead,
}) => {
  const { authorName } = author;

  const image =
    typeof img === 'object' ? (
      <Styled.GatsbyImg
        fluid={img}
        style={{ border: first ? 0 : imgStyle, height: first && '100%' }}
      />
    ) : (
      <Styled.CustomImg
        src={img}
        alt="Article hero"
        title={title}
        style={{ border: first ? 0 : imgStyle, height: first && '100%' }}
        loading="lazy"
        isList={isList}
      />
    );

  const formattedDate = format(new Date(date), 'MMMM dd, yyyy');

  return first ? (
    <Styled.CustomLink href={url}>
      <Styled.FirstPreview>
        <Styled.ImageBox isList={isList} className="first">
          <Styled.FirstImg
            src={img}
            alt="Article hero"
            title={title}
            style={{ border: first ? 0 : imgStyle, height: first && '100%' }}
            loading="lazy"
          />
        </Styled.ImageBox>
        <Styled.FirstContent>
          <p>{list || 'Articles'}</p>
          <Styled.Title>{title}</Styled.Title>
          <p className="desc">{description}</p>
          <p className="name bigger">by {authorName}</p>
          <Styled.TimeToRead className="bigger">
            {blogDate || formattedDate}
            {timeToRead ? <span>{timeToRead} min read</span> : null}
          </Styled.TimeToRead>
        </Styled.FirstContent>
      </Styled.FirstPreview>
    </Styled.CustomLink>
  ) : (
    <Styled.CustomLink href={url}>
      <Styled.Preview isList={isList}>
        <Styled.ImageBox isList={isList}>{image}</Styled.ImageBox>
        <Styled.Content isList={isList}>
          <p>{list || group || 'Articles'}</p>
          <Styled.Title>{title}</Styled.Title>
          <p className="name">by {authorName}</p>
          <Styled.TimeToRead>
            {blogDate || formattedDate}
            {timeToRead ? <span>{timeToRead} min read</span> : null}
          </Styled.TimeToRead>
        </Styled.Content>
      </Styled.Preview>
    </Styled.CustomLink>
  );
};

ArticlePreview.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  img: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  url: PropTypes.string.isRequired,
  author: PropTypes.oneOfType([PropTypes.object]).isRequired,
  isList: PropTypes.bool,
  list: PropTypes.string,
  group: PropTypes.string,
  imgStyle: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  first: PropTypes.bool,
  timeToRead: PropTypes.number,
  blogDate: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
};

ArticlePreview.defaultProps = {
  list: null,
  group: null,
  imgStyle: null,
  timeToRead: null,
  blogDate: null,
  date: null,
  first: false,
  isList: false,
  description: '',
};

export default ArticlePreview;
